module.exports = __webpack_public_path__ + "static/media/apple-green.70e3a090.png";